import * as graphql from 'generated/graphql';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';
import usePreferredTranslation from 'packages/kakapo-ui-application/hooks/usePreferredTranslation';

export default function Title(props: { item: graphql.EvaluationTitleItem; readonly?: boolean }) {
	const { translate } = usePreferredTranslation();

	return <SectionTitle>{translate(props.item.text)}</SectionTitle>;
}
